module.exports = __webpack_public_path__ + "img/internet.7c013a1f.png";